import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { EditionService } from '../../shared/services/edition.service';

@Component({
  selector: 'app-user-permission-role',
  templateUrl: './user-permission-role.component.html',
  styleUrls: ['./user-permission-role.component.less']
})
export class UserPermissionRoleComponent implements OnInit {
  public roleName: string;
  private scopedTargetId: string;
  private scopedTargetType: string;

  constructor(
    private route: ActivatedRoute,
    private editionService: EditionService
  ) { }

  ngOnInit() {
    this.editionService.getEdition().subscribe(edition => {
      this.scopedTargetId = edition.id.toString();
      this.scopedTargetType = "edition";
      this.setElementAttributes();
    });
  }

  private setElementAttributes() {
    this.route.params.subscribe(params => {
      this.roleName = params['roleName'];

      const element = document.getElementById("user-permission-role");

      element.setAttribute("access-role-name", this.roleName);
      element.setAttribute("scoped-target-id", this.scopedTargetId);
      element.setAttribute("scoped-target-type", this.scopedTargetType);
    });
  }
}



// WEBPACK FOOTER //
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/global-settings/permission-settings/user-permission-role.component.ts